define(function (require) {
    "use strict";
    var LE = require("app");
    var BaseModel = require("models/BaseModel");

    var NAME = "SpecialOccasionEventsTableModel";

    var EMPTY_FILTERS = {};

    var SpecialOccasionEventsTableModel = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        SpecialOccasionEventsTableModel = BaseModel.extend({
            name: NAME,
            defaults: {
                filters: EMPTY_FILTERS,
                comparators: {
                    "timeFrame": "timeFrame"
                }
            },

            pluck: function (_model) {
                return true;
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return SpecialOccasionEventsTableModel;
});
